import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import AnimateOnScroll from './AnimateOnScroll';
import { ctaSection } from '../content/landingContent';

export const CTASection = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 lg:py-32 bg-slate-600">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <AnimateOnScroll>
          <div className="space-y-8">
            <h2 className="text-2xl lg:text-3xl font-bold text-white tracking-tight">
              {ctaSection.headline}
            </h2>
            <p className="text-xl text-white max-w-2xl mx-auto leading-relaxed">
              {ctaSection.subheadline}
            </p>
            <div className="pt-4 flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg"
                onClick={scrollToContact}
                className="bg-white hover:bg-stone-100 text-slate-700 rounded-lg transition-all duration-300 text-lg px-10 py-7 group"
              >
                {ctaSection.primaryCTA}
                <ArrowRight className="ml-2 h-6 w-6 group-hover:translate-x-1 transition-transform duration-200" />
              </Button>
              <Button 
                size="lg"
                variant="outline"
                onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                className="border border-white text-white hover:bg-slate-500 rounded-lg transition-all duration-300 text-lg px-10 py-7"
              >
                {ctaSection.secondaryCTA}
              </Button>
            </div>
            <p className="text-sm text-slate-200 pt-4">
              {ctaSection.disclaimer}
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default CTASection;